module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/component/forgotpassword/forgotpassword.component.scss
// module id = ./src/app/component/forgotpassword/forgotpassword.component.scss
// module chunks = main